(ns livefeed.footer.scrollable-footer
  (:require [reagent.core :as reagent :refer [atom with-let]]
            [reagent.dom :as rdom]
            ["react" :as react]
            ["hammerjs" :as hammer]
            [livefeed.state :as state]))

(defn component [& children]
  (let [hammer-manager (atom nil)
        snap-left (atom 0)
        left (atom 0)
        panning? (atom false)
        container-ref (react/createRef)
        scroller-ref (react/createRef)
        max-pan (fn []
                  (- (.-clientWidth (.-current container-ref))
                     (.-scrollWidth (.-current scroller-ref))))
        calculate-left (fn [x]
                         (-> (+ x @snap-left)
                             (min 0)
                             (max (max-pan))))
        pan (fn [e]
              (reset! panning? true)
              (reset! left (calculate-left (.-deltaX e))))
        pan-end (fn [e]
                  (reset! panning? false)
                  (let [max-left (max-pan)
                        v (if (and (zero? @snap-left)
                                   (< (.-deltaX e) -50))
                            max-left
                            0)]
                    (reset! left v)
                    (reset! snap-left v)))
        watch-input-focus (fn [_ _ _ focused?]
                            (when focused?
                              (reset! left 0)
                              (reset! snap-left 0)))]
    (reagent/create-class
     {:component-did-mount    (fn [this]
                                (let [hm (hammer/Manager. (rdom/dom-node this) #js {:cssProps #js {:userSelect nil}})]
                                  (reset! hammer-manager hm)
                                  (doto hm
                                    (.add (hammer/Pan. #js {:direction hammer/DIRECTION_HORIZONTAL
                                                            :threshold 20}))
                                    (.on "pan" pan)
                                    (.on "panend" pan-end)
                                    (.on "pancancel" pan-end))
                                  (add-watch state/input-focused? :watch-input-focus watch-input-focus)))
      :component-will-unmount (fn []
                                (remove-watch state/input-focused? :watch-input-focus)
                                (when-let [^js hm @hammer-manager]
                                  (.destroy hm)))
      :reagent-render         (fn [& children]
                                [:div.yle-livefeed__scrollable-footer {:ref container-ref}
                                 (into [:div.yle-livefeed__scrollable-footer__contents
                                        {:class (when @panning? :yle-livefeed__scrollable-footer__contents--panning)
                                         :ref   scroller-ref
                                         :style {:left (str @left "px")}}]
                                       children)])})))
